// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.under-img {
  margin-bottom: 80px !important;
}

.header-img {
  width: 125px !important;
  margin-top: 15px !important;
}

.login button {
  background-color: #192352 !important;
}

.header-img {
  width: 73px !important;
}

html, body, app-root, app-login-v4 {
  height: 100%;
  display: block;
}

app-login-v4 {
  display: flex;
  flex-direction: column;
}

body {
  background-color: #f8f8f8;
  position: relative;
  margin: 0 !important;
}

.header-img {
  margin: 30px 30px 24px 30px;
  width: 73px;
}

.under-img, .under-img span {
  font-family: "asapregular";
  font-size: 35px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 3.98px;
  text-align: center;
  color: #313541;
  margin-bottom: 75px;
}

.under-img span {
  font-weight: 600;
}

.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-xs-1,
.col-xs-10,
.col-xs-11,
.col-xs-12,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9 {
  padding: 0 !important;
}

.login-container {
  margin: auto !important;
  height: 100vh;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.wrapper {
  margin: auto;
  width: 484px;
  text-align: center;
  padding: 40px 80px 50px 80px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff !important;
  box-shadow: 0 2px 6px 0 rgba(176, 186, 197, 0.6);
  z-index: 10;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 780px;
  position: absolute;
  vertical-align: middle;
}

.wrapper input {
  width: 100%;
  height: 55px;
  border-radius: 5px;
  border: solid 1px #ccd2d5;
  margin-bottom: 20px;
  background-color: transparent;
  padding-left: 57.5px;
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d;
  outline: none !important;
}

input:focus {
  border-color: #447695 !important;
}

.wrapper input:last-of-type {
  margin-top: 0px;
}

.wrapper img {
  width: 75px;
}

.wrapper input:focus {
  border: solid 1px rgb(24, 115, 177);
}

.control-wrapper {
  text-align: left;
}

.input-password,
.input-username {
  position: relative;
}

.input-password:after,
.input-username:after {
  background: url('icon-password@3x.png');
  content: "";
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 18px;
  top: 16.5px;
}

.input-username:after {
  background-image: url('icon-username@3x.png');
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}

.input-username {
  margin-top: 30px !important;
}

h1,
span {
  font-family: "asapregular";
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  /*letter-spacing: 4px;*/
  text-align: center;
  color: #313541;
}

h1 span {
  font-family: "asapmedium";
}

input[type=checkbox] {
  width: 18px;
  height: 100%;
  margin: 0 !important;
}

.sided {
  height: 30px;
  display: inline-table;
  table-layout: fixed;
  width: 100%;
  text-align: left;
}

.sided * {
  vertical-align: middle;
}

.sided input {
  display: none;
}

.sided label {
  width: 19px;
}

.sided .sided-child {
  margin-bottom: 10px;
}

.sided p {
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #81898c;
  border-color: #ccd2d5;
  margin: 0 !important;
  padding-left: 12px !important;
  width: 100%;
  display: inline;
}

.login button {
  background-color: #192352;
  height: 55px;
  border-radius: 5px;
  width: 100%;
  font-family: "asapregular" !important;
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  border: 0 !important;
  color: #ffffff;
  cursor: pointer;
}

label input {
  display: none; /* Hide the default checkbox */
}

/* Style the artificial checkbox */
label span {
  height: 19px;
  width: 19px;
  border: 1px solid #ccd2d5;
  display: inline-block;
  position: relative;
  border-radius: 3px;
  cursor: pointer;
}

/* Style its checked state...with a ticked icon */
[type=checkbox]:checked + span:before {
  content: "";
  width: 14px;
  height: 9px;
  position: absolute;
  top: 6px;
  left: 2px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('cb-check.png');
}

.options {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}

.options a,
.options a:hover,
.options a:visited {
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  cursor: pointer;
  text-decoration: none !important;
  color: #81898c;
}

.options a {
  display: block;
  margin-bottom: 15px;
}

.forgot-username-label {
  margin-bottom: 10px;
}

.inp-container {
  margin-bottom: 0 !important;
}

#clients {
  margin-top: 250px;
  text-align: center;
  margin-bottom: 70px;
}

.newpassword-label {
  margin-bottom: 20px;
}

.col {
  height: 252px;
}

#clients .logo {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: auto;
  height: 252px;
  display: inline-block;
  vertical-align: middle;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

@media screen and (max-width: 1200px) {
  .logo {
    width: 100%;
    margin-bottom: 50px !important;
  }
  #clients {
    margin-top: 150px !important;
  }
}
.unauthorize-message {
  padding: 20px;
  background-color: #d0021b;
  color: white;
  text-align: center;
  font-family: "asapregular" !important;
}

.error-messages {
  /*height:35px;*/
  padding-top: 10px;
}

.error-messages p {
  font-family: "asapregular";
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #e34c4c;
}

h1 {
  line-height: normal !important;
  padding: 0 !important;
}

button:disabled {
  background-color: #bebbbb !important;
}

.btn-loader {
  position: relative;
  margin-top: 55px;
}

.btn-loader img {
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 30px;
  width: 30px;
}

.alerts .login-close-alert {
  top: 38px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/configuration/login.scss","webpack://./../../Projects%20TFS/WebGalis-Core-FE/src/app/components/login-views/login-v3-cro/login-v3-cro.component.scss","webpack://./src/app/components/login-views/login-v3-cro/login-v3-cro.component.scss"],"names":[],"mappings":"AAGA;EACI,8BAAA;ACFJ;;ADKA;EACI,uBAAA;EACA,2BAAA;ACFJ;;ADKA;EACI,oCAAA;ACFJ;;ADKA;EACI,sBAAA;ACFJ;;ADKA;EACI,YAAA;EACA,cAAA;ACFJ;;ADKA;EACI,aAAA;EACA,sBAAA;ACFJ;;ACtBA;EACI,yBAAA;EACA,kBAAA;EACA,oBAAA;ADyBJ;;ACtBA;EACI,2BAAA;EACA,WAAA;ADyBJ;;ACtBA;EACI,0BAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;ADyBJ;;ACtBA;EACI,gBAAA;ADyBJ;;ACtBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDI,qBAAA;ADyBJ;;ACtBA;EACI,uBAAA;EACA,aAAA;ADyBJ;;ACtBA;EACI,yBAAA;EACA,0BAAA;ADyBJ;;ACtBA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gDAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;ADyBJ;;ACtBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,wBAAA;ADyBJ;;ACtBA;EACI,gCAAA;ADyBJ;;ACtBA;EACI,eAAA;ADyBJ;;ACtBA;EACI,WAAA;ADyBJ;;ACtBA;EACI,mCAAA;ADyBJ;;ACtBA;EACI,gBAAA;ADyBJ;;ACtBA;;EAEI,kBAAA;ADyBJ;;ACtBA;;EAEI,uCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;ADyBJ;;ACtBA;EACI,6CAAA;ADyBJ;;ACtBA;EACI,8CAAA;ADyBJ;;ACtBA;EACI,2BAAA;ADyBJ;;ACrBA;;EAEI,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;ADwBJ;;ACrBA;EACI,yBAAA;ADwBJ;;ACrBA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;ADwBJ;;ACrBA;EACI,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;ADwBJ;;ACrBA;EACI,sBAAA;ADwBJ;;ACrBA;EACI,aAAA;ADwBJ;;ACrBA;EACI,WAAA;ADwBJ;;ACrBA;EACI,mBAAA;ADwBJ;;ACrBA;EACI,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;ADwBJ;;ACrBA;EACI,yBFpPa;EEqPb,YAAA;EACA,kBAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;ADwBJ;;ACNA;EACI,aAAA,EAAA,8BAAA;ADSJ;;ACNE,kCAAA;AACA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;ADSJ;;ACNE,iDAAA;AACA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,qCAAA;ADSJ;;ACNA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;ADSJ;;ACNA;;;EAGI,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,cAAA;ADSJ;;ACNA;EACI,cAAA;EACA,mBAAA;ADSJ;;ACNA;EACI,mBAAA;ADSJ;;ACNA;EACI,2BAAA;ADSJ;;ACNA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;ADSJ;;ACNA;EACI,mBAAA;ADSJ;;ACNA;EACI,aAAA;ADSJ;;ACNA;EACI,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;ADSJ;;ACNA;EACI,wBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;ADSJ;;ACNA;EACI,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;ADSJ;;ACNA;EACI,WAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;ADSJ;;ACNA;EACI,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;ADSJ;;ACNA;EACI;IACI,WAAA;IACA,8BAAA;EDSN;ECNE;IACI,4BAAA;EDQN;AACF;ACLA;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;ADOJ;;ACJA;EACI,eAAA;EACA,iBAAA;ADOJ;;ACJA;EACI,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;ADOJ;;ACJA;EACI,8BAAA;EACA,qBAAA;ADOJ;;ACJA;EACI,oCAAA;ADOJ;;ACJE;EACI,kBAAA;EACA,gBAAA;ADON;;ACLE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;ADQJ;;ACLA;EACI,oBAAA;ADQJ","sourcesContent":["$highlightColor: #192352;\r\n$loginPageButtonColor: #192352;\r\n\r\n.under-img {\r\n    margin-bottom: 80px !important;\r\n}\r\n\r\n.header-img {\r\n    width: 125px !important;\r\n    margin-top: 15px !important\r\n}\r\n\r\n.login button {\r\n    background-color: $loginPageButtonColor !important;\r\n}\r\n\r\n.header-img {\r\n    width: 73px !important;\r\n}\r\n\r\nhtml, body, app-root, app-login-v4 {\r\n    height: 100%;\r\n    display: block;\r\n}\r\n\r\napp-login-v4 {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n",".under-img {\n  margin-bottom: 80px !important;\n}\n\n.header-img {\n  width: 125px !important;\n  margin-top: 15px !important;\n}\n\n.login button {\n  background-color: #192352 !important;\n}\n\n.header-img {\n  width: 73px !important;\n}\n\nhtml, body, app-root, app-login-v4 {\n  height: 100%;\n  display: block;\n}\n\napp-login-v4 {\n  display: flex;\n  flex-direction: column;\n}\n\nbody {\n  background-color: #f8f8f8;\n  position: relative;\n  margin: 0 !important;\n}\n\n.header-img {\n  margin: 30px 30px 24px 30px;\n  width: 73px;\n}\n\n.under-img, .under-img span {\n  font-family: \"asapregular\";\n  font-size: 35px;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 3.98px;\n  text-align: center;\n  color: #313541;\n  margin-bottom: 75px;\n}\n\n.under-img span {\n  font-weight: 600;\n}\n\n.col-lg-1,\n.col-lg-10,\n.col-lg-11,\n.col-lg-12,\n.col-lg-2,\n.col-lg-3,\n.col-lg-4,\n.col-lg-5,\n.col-lg-6,\n.col-lg-7,\n.col-lg-8,\n.col-lg-9,\n.col-md-1,\n.col-md-10,\n.col-md-11,\n.col-md-12,\n.col-md-2,\n.col-md-3,\n.col-md-4,\n.col-md-5,\n.col-md-6,\n.col-md-7,\n.col-md-8,\n.col-md-9,\n.col-sm-1,\n.col-sm-10,\n.col-sm-11,\n.col-sm-12,\n.col-sm-2,\n.col-sm-3,\n.col-sm-4,\n.col-sm-5,\n.col-sm-6,\n.col-sm-7,\n.col-sm-8,\n.col-sm-9,\n.col-xs-1,\n.col-xs-10,\n.col-xs-11,\n.col-xs-12,\n.col-xs-2,\n.col-xs-3,\n.col-xs-4,\n.col-xs-5,\n.col-xs-6,\n.col-xs-7,\n.col-xs-8,\n.col-xs-9 {\n  padding: 0 !important;\n}\n\n.login-container {\n  margin: auto !important;\n  height: 100vh;\n}\n\n.row {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.wrapper {\n  margin: auto;\n  width: 484px;\n  text-align: center;\n  padding: 40px 80px 50px 80px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  background-color: #ffffff !important;\n  box-shadow: 0 2px 6px 0 rgba(176, 186, 197, 0.6);\n  z-index: 10;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 780px;\n  position: absolute;\n  vertical-align: middle;\n}\n\n.wrapper input {\n  width: 100%;\n  height: 55px;\n  border-radius: 5px;\n  border: solid 1px #ccd2d5;\n  margin-bottom: 20px;\n  background-color: transparent;\n  padding-left: 57.5px;\n  font-family: \"asapregular\";\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #3d464d;\n  outline: none !important;\n}\n\ninput:focus {\n  border-color: #447695 !important;\n}\n\n.wrapper input:last-of-type {\n  margin-top: 0px;\n}\n\n.wrapper img {\n  width: 75px;\n}\n\n.wrapper input:focus {\n  border: solid 1px rgb(24, 115, 177);\n}\n\n.control-wrapper {\n  text-align: left;\n}\n\n.input-password,\n.input-username {\n  position: relative;\n}\n\n.input-password:after,\n.input-username:after {\n  background: url(../../../../assets/css/images/platform/icon-password@3x.png);\n  content: \"\";\n  width: 22px;\n  height: 23px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  position: absolute;\n  left: 18px;\n  top: 16.5px;\n}\n\n.input-username:after {\n  background-image: url(../../../../assets/css/images/platform/icon-username@3x.png);\n}\n\ninput:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0px 1000px white inset;\n}\n\n.input-username {\n  margin-top: 30px !important;\n}\n\nh1,\nspan {\n  font-family: \"asapregular\";\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  /*letter-spacing: 4px;*/\n  text-align: center;\n  color: #313541;\n}\n\nh1 span {\n  font-family: \"asapmedium\";\n}\n\ninput[type=checkbox] {\n  width: 18px;\n  height: 100%;\n  margin: 0 !important;\n}\n\n.sided {\n  height: 30px;\n  display: inline-table;\n  table-layout: fixed;\n  width: 100%;\n  text-align: left;\n}\n\n.sided * {\n  vertical-align: middle;\n}\n\n.sided input {\n  display: none;\n}\n\n.sided label {\n  width: 19px;\n}\n\n.sided .sided-child {\n  margin-bottom: 10px;\n}\n\n.sided p {\n  font-family: \"asapregular\";\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #81898c;\n  border-color: #ccd2d5;\n  margin: 0 !important;\n  padding-left: 12px !important;\n  width: 100%;\n  display: inline;\n}\n\n.login button {\n  background-color: #192352;\n  height: 55px;\n  border-radius: 5px;\n  width: 100%;\n  font-family: \"asapregular\" !important;\n  font-size: 14px;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  border: 0 !important;\n  color: #ffffff;\n  cursor: pointer;\n}\n\nlabel input {\n  display: none; /* Hide the default checkbox */\n}\n\n/* Style the artificial checkbox */\nlabel span {\n  height: 19px;\n  width: 19px;\n  border: 1px solid #ccd2d5;\n  display: inline-block;\n  position: relative;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n/* Style its checked state...with a ticked icon */\n[type=checkbox]:checked + span:before {\n  content: \"\";\n  width: 14px;\n  height: 9px;\n  position: absolute;\n  top: 6px;\n  left: 2px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-image: url(../../../../assets/css/images/platform/cb-check.png);\n}\n\n.options {\n  margin-top: 30px;\n  display: flex;\n  flex-direction: column;\n}\n\n.options a,\n.options a:hover,\n.options a:visited {\n  font-family: \"asapregular\";\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  cursor: pointer;\n  text-decoration: none !important;\n  color: #81898c;\n}\n\n.options a {\n  display: block;\n  margin-bottom: 15px;\n}\n\n.forgot-username-label {\n  margin-bottom: 10px;\n}\n\n.inp-container {\n  margin-bottom: 0 !important;\n}\n\n#clients {\n  margin-top: 250px;\n  text-align: center;\n  margin-bottom: 70px;\n}\n\n.newpassword-label {\n  margin-bottom: 20px;\n}\n\n.col {\n  height: 252px;\n}\n\n#clients .logo {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin: auto;\n  height: 252px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  font-family: \"asapregular\";\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #3d464d !important;\n}\n\n::-moz-placeholder {\n  /* Firefox 19+ */\n  font-family: \"asapregular\";\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #3d464d !important;\n}\n\n:-ms-input-placeholder {\n  /* IE 10+ */\n  font-family: \"asapregular\";\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #3d464d !important;\n}\n\n:-moz-placeholder {\n  /* Firefox 18- */\n  font-family: \"asapregular\";\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #3d464d !important;\n}\n\n@media screen and (max-width: 1200px) {\n  .logo {\n    width: 100%;\n    margin-bottom: 50px !important;\n  }\n  #clients {\n    margin-top: 150px !important;\n  }\n}\n.unauthorize-message {\n  padding: 20px;\n  background-color: #d0021b;\n  color: white;\n  text-align: center;\n  font-family: \"asapregular\" !important;\n}\n\n.error-messages {\n  /*height:35px;*/\n  padding-top: 10px;\n}\n\n.error-messages p {\n  font-family: \"asapregular\";\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #e34c4c;\n}\n\nh1 {\n  line-height: normal !important;\n  padding: 0 !important;\n}\n\nbutton:disabled {\n  background-color: #bebbbb !important;\n}\n\n.btn-loader {\n  position: relative;\n  margin-top: 55px;\n}\n\n.btn-loader img {\n  position: absolute;\n  right: 10px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  height: 30px;\n  width: 30px;\n}\n\n.alerts .login-close-alert {\n  top: 38px !important;\n}","@import \"../../../../assets/configuration/login.scss\";\r\n\r\n\r\nbody {\r\n    background-color: #f8f8f8;\r\n    position: relative;\r\n    margin: 0 !important;\r\n}\r\n\r\n.header-img{\r\n    margin: 30px 30px 24px 30px;\r\n    width:73px;\r\n}\r\n\r\n.under-img,.under-img span{\r\n    font-family: 'asapregular';\r\n    font-size: 35px;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: normal;\r\n    letter-spacing: 3.98px;\r\n    text-align: center;\r\n    color: #313541;\r\n    margin-bottom: 75px;\r\n}\r\n\r\n.under-img span{\r\n    font-weight: 600;\r\n}\r\n\r\n.col-lg-1,\r\n.col-lg-10,\r\n.col-lg-11,\r\n.col-lg-12,\r\n.col-lg-2,\r\n.col-lg-3,\r\n.col-lg-4,\r\n.col-lg-5,\r\n.col-lg-6,\r\n.col-lg-7,\r\n.col-lg-8,\r\n.col-lg-9,\r\n.col-md-1,\r\n.col-md-10,\r\n.col-md-11,\r\n.col-md-12,\r\n.col-md-2,\r\n.col-md-3,\r\n.col-md-4,\r\n.col-md-5,\r\n.col-md-6,\r\n.col-md-7,\r\n.col-md-8,\r\n.col-md-9,\r\n.col-sm-1,\r\n.col-sm-10,\r\n.col-sm-11,\r\n.col-sm-12,\r\n.col-sm-2,\r\n.col-sm-3,\r\n.col-sm-4,\r\n.col-sm-5,\r\n.col-sm-6,\r\n.col-sm-7,\r\n.col-sm-8,\r\n.col-sm-9,\r\n.col-xs-1,\r\n.col-xs-10,\r\n.col-xs-11,\r\n.col-xs-12,\r\n.col-xs-2,\r\n.col-xs-3,\r\n.col-xs-4,\r\n.col-xs-5,\r\n.col-xs-6,\r\n.col-xs-7,\r\n.col-xs-8,\r\n.col-xs-9 {\r\n    padding: 0 !important;\r\n}\r\n\r\n.login-container {\r\n    margin: auto !important;\r\n    height: 100vh;\r\n}\r\n\r\n.row {\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n}\r\n\r\n.wrapper {\r\n    margin: auto;\r\n    width: 484px;\r\n    text-align: center;\r\n    padding: 40px 80px 50px 80px;\r\n    box-sizing: border-box;\r\n    border-radius: 5px;\r\n    background-color: #ffffff !important;\r\n    box-shadow: 0 2px 6px 0 rgb(176 186 197 / 60%);\r\n    z-index: 10;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    height: 780px;\r\n    position: absolute;\r\n    vertical-align: middle;\r\n}\r\n\r\n.wrapper input {\r\n    width: 100%;\r\n    height: 55px;\r\n    border-radius: 5px;\r\n    border: solid 1px #ccd2d5;\r\n    margin-bottom: 20px;\r\n    background-color: transparent;\r\n    padding-left: 57.5px;\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d;\r\n    outline: none !important;\r\n}\r\n\r\ninput:focus{\r\n    border-color: #447695 !important;\r\n}\r\n\r\n.wrapper input:last-of-type {\r\n    margin-top: 0px;\r\n}\r\n\r\n.wrapper img {\r\n    width: 75px;\r\n}\r\n\r\n.wrapper input:focus {\r\n    border: solid 1px rgb(24, 115, 177);\r\n}\r\n\r\n.control-wrapper {\r\n    text-align: left;\r\n}\r\n\r\n.input-password,\r\n.input-username {\r\n    position: relative;\r\n}\r\n\r\n.input-password:after,\r\n.input-username:after {\r\n    background: url(../../../../assets/css/images/platform/icon-password@3x.png);\r\n    content: \"\";\r\n    width: 22px;\r\n    height: 23px;\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n    position: absolute;\r\n    left: 18px;\r\n    top: 16.5px;\r\n}\r\n\r\n.input-username:after {\r\n    background-image: url(../../../../assets/css/images/platform/icon-username@3x.png);\r\n}\r\n\r\ninput:-webkit-autofill {\r\n    -webkit-box-shadow: 0 0 0px 1000px white inset;\r\n}\r\n\r\n.input-username {\r\n    margin-top: 30px !important;\r\n}\r\n\r\n\r\nh1,\r\nspan {\r\n    font-family: \"asapregular\";\r\n    font-size: 20px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    /*letter-spacing: 4px;*/\r\n    text-align: center;\r\n    color: #313541;\r\n}\r\n\r\nh1 span {\r\n    font-family: \"asapmedium\";\r\n}\r\n\r\ninput[type=\"checkbox\"] {\r\n    width: 18px;\r\n    height: 100%;\r\n    margin: 0 !important;\r\n}\r\n\r\n.sided {\r\n    height: 30px;\r\n    display: inline-table;\r\n    table-layout: fixed;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.sided * {    \r\n    vertical-align: middle;\r\n}\r\n\r\n.sided input{\r\n    display: none;\r\n}\r\n\r\n.sided label{\r\n    width: 19px;\r\n}\r\n\r\n.sided .sided-child{\r\n    margin-bottom:10px;\r\n}\r\n\r\n.sided p {\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #81898c;\r\n    border-color: #ccd2d5;\r\n    margin: 0 !important;\r\n    padding-left: 12px !important;\r\n    width: 100%;\r\n    display: inline;    \r\n}\r\n\r\n.login button {\r\n    background-color: $highlightColor;\r\n    height: 55px;\r\n    border-radius: 5px;\r\n    width: 100%;\r\n    font-family: \"asapregular\" !important;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    border: 0 !important;\r\n    color: #ffffff;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\nlabel input {\r\n    display: none; /* Hide the default checkbox */\r\n  }\r\n  \r\n  /* Style the artificial checkbox */\r\n  label span {\r\n    height: 19px;\r\n    width: 19px;\r\n    border: 1px solid #ccd2d5;\r\n    display: inline-block;\r\n    position: relative;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* Style its checked state...with a ticked icon */\r\n  [type=checkbox]:checked + span:before {\r\n    content: \"\";\r\n    width: 14px;\r\n    height: 9px;\r\n    position: absolute;\r\n    top: 6px;\r\n    left: 2px;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n    background-image: url(../../../../assets/css/images/platform/cb-check.png);\r\n  }\r\n\r\n.options {\r\n    margin-top: 30px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.options a,\r\n.options a:hover,\r\n.options a:visited {\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: left;\r\n    cursor: pointer;\r\n    text-decoration: none !important;\r\n    color: #81898c;\r\n}\r\n  \r\n.options a {\r\n    display: block;\r\n    margin-bottom: 15px;        \r\n}\r\n\r\n.forgot-username-label{\r\n    margin-bottom: 10px;\r\n}\r\n  \r\n.inp-container {\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n#clients {\r\n    margin-top: 250px;\r\n    text-align: center;\r\n    margin-bottom: 70px;\r\n}\r\n\r\n.newpassword-label{\r\n    margin-bottom:20px;\r\n}\r\n\r\n.col {\r\n    height: 252px;\r\n}\r\n\r\n#clients .logo {\r\n    background-size: contain;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    margin: auto;\r\n    height: 252px;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n\r\n::-webkit-input-placeholder {\r\n    /* Chrome/Opera/Safari */\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d !important;\r\n}\r\n\r\n::-moz-placeholder {\r\n    /* Firefox 19+ */\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d !important;\r\n}\r\n\r\n:-ms-input-placeholder {\r\n    /* IE 10+ */\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d !important;\r\n}\r\n\r\n:-moz-placeholder {\r\n    /* Firefox 18- */\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #3d464d !important;\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n    .logo {\r\n        width: 100%;\r\n        margin-bottom: 50px !important;\r\n    }\r\n\r\n    #clients {\r\n        margin-top: 150px !important;\r\n    }\r\n}\r\n\r\n.unauthorize-message {\r\n    padding: 20px;\r\n    background-color: #d0021b;\r\n    color: white;\r\n    text-align: center;\r\n    font-family: \"asapregular\" !important;\r\n}\r\n\r\n.error-messages {\r\n    /*height:35px;*/\r\n    padding-top: 10px;\r\n}\r\n\r\n.error-messages p {\r\n    font-family: \"asapregular\";\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    text-align: center;\r\n    color: #e34c4c;\r\n}\r\n\r\nh1{\r\n    line-height: normal !important;\r\n    padding: 0 !important;\r\n}\r\n\r\nbutton:disabled {\r\n    background-color: #bebbbb !important;\r\n  }\r\n\r\n  .btn-loader{\r\n      position: relative;\r\n      margin-top: 55px;\r\n  }\r\n  .btn-loader img{\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 0;\r\n    bottom: 0;\r\n    margin: auto;\r\n    height: 30px;\r\n    width: 30px;\r\n  }\r\n\r\n.alerts .login-close-alert {\r\n    top:38px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
